(() => {
    const allLinks = document.querySelectorAll("story-links a, .quick-links a");

    if (allLinks.length > 0) {
        allLinks.forEach((item) => {
            item.addEventListener("click", (e) => {
                const collectionTitle =
                    e.currentTarget.getAttribute("collection-title");
                const gtmData = {
                    event: "storyLinks",
                    category: collectionTitle,
                };

                window.dataLayer.push(gtmData);
            });
        });
    }
})();
